<footer>
    Footer Works!
</footer>